import axios from '@/plugins/axios';
import { useToast } from '@/composables/use-toast.js';
import { logApiError } from '@/services/api.js';

const { addToast } = useToast();
const saleBaseURL = '/api/sales';

export const refundUSDC = async (tx_hash) => {
    try {
        const response = await axios.post(`${saleBaseURL}/refund`, tx_hash);
        return response.data;
    } catch (error) {
        logApiError(error, 'POST', `${saleBaseURL}/refund/${tx_hash}`);
        addToast('Error refunding USDC', 'error');
        return false;
    }
}